export function translate(property, language){
    const languages = ['en', 'es','jp','pt'];
    if(!languages.includes(language)){
        language = 'en';
    }
    language = language.charAt(0).toUpperCase() + language.slice(1);
    return (property + language);
}